/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var VNodeList = /** @class */ (function () {
    function VNodeList(parent) {
        this.parent = parent;
        this.parent = parent;
    }
    Object.defineProperty(VNodeList.prototype, "length", {
        get: function () {
            return this.parent.rawChildren.length;
        },
        set: function (length) {
            this.splice(length);
        },
        enumerable: false,
        configurable: true
    });
    VNodeList.prototype.item = function (index) {
        var _a;
        var node = this.parent.rawChildren[index];
        if (node) {
            this.ensureAdd([node]);
        }
        return (_a = node === null || node === void 0 ? void 0 : node.$$vnode_proxy) !== null && _a !== void 0 ? _a : null;
    };
    VNodeList.prototype.indexOf = function (node) {
        var idx = this.parent.rawChildren.indexOf(node);
        if (idx !== -1) {
            this.ensureAdd([node]);
        }
        return idx;
    };
    VNodeList.prototype.push = function () {
        var _a;
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        var result = (_a = this.parent.rawChildren).push.apply(_a, children);
        this.ensureAdd(children);
        return result;
    };
    VNodeList.prototype.unshift = function () {
        var _a;
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        var result = (_a = this.parent.rawChildren).unshift.apply(_a, children);
        this.ensureAdd(children);
        return result;
    };
    VNodeList.prototype.splice = function (start, deleteCount) {
        var _a;
        var children = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            children[_i - 2] = arguments[_i];
        }
        deleteCount !== null && deleteCount !== void 0 ? deleteCount : (deleteCount = this.parent.rawChildren.length - start);
        var deleted = (_a = this.parent.rawChildren).splice.apply(_a, __spreadArray([start, deleteCount], children, false));
        this.ensureAdd(children);
        this.ensureRemove(deleted);
        return deleted;
    };
    VNodeList.prototype.pop = function () {
        var node = this.parent.rawChildren.pop();
        if (node) {
            this.ensureRemove([node]);
        }
        return node;
    };
    VNodeList.prototype.shift = function () {
        var node = this.parent.rawChildren.shift();
        if (node) {
            this.ensureRemove([node]);
        }
        return node;
    };
    VNodeList.prototype.clear = function () {
        this.ensureRemove(this.parent.rawChildren);
        this.parent.rawChildren.length = 0;
    };
    VNodeList.prototype.ensureAdd = function (nodes) {
        var _a, _b;
        var _c;
        if (nodes === void 0) { nodes = this.parent.rawChildren; }
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var child = nodes_1[_i];
            (_a = child.$$vnode_proxy) !== null && _a !== void 0 ? _a : (child.$$vnode_proxy = createVNodeProxy(child, this.parent));
            (_b = (_c = child.$$vnode_proxy).parent) !== null && _b !== void 0 ? _b : (_c.parent = this.parent);
            child.$$vnode_proxy.parent === this.parent;
        }
    };
    VNodeList.prototype.ensureRemove = function (nodes) {
        var _a;
        for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
            var child = nodes_2[_i];
            if (!((_a = child.$$vnode_proxy) === null || _a === void 0 ? void 0 : _a.parent)) {
                continue;
            }
            child.$$vnode_proxy.parent === this.parent;
            child.$$vnode_proxy.parent = null;
        }
    };
    return VNodeList;
}());

var assign = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length < 2) {
        return args[0];
    }
    var target = args.shift();
    var sources = args;
    if (!target || typeof target !== 'object') {
        return target;
    }
    if (typeof Object.assign === 'function') {
        return Object.assign.apply(Object, __spreadArray([target], sources, false));
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (!source || typeof source !== 'object') {
            continue;
        }
        for (var _b = 0, _c = Object.keys(source); _b < _c.length; _b++) {
            var key = _c[_b];
            target[key] = source[key];
        }
    }
    return target;
};

var camelCase = function (arg) {
    var source = arg !== null && arg !== void 0 ? arg : '';
    source = String(source);
    if (!source.length) {
        return source;
    }
    var target = source.replace(/[\-_]+(.)/g, function (m, p1) { return p1.toUpperCase(); });
    if (!target.length) {
        return target;
    }
    return [target[0].toLowerCase(), target.substring(1)].join('');
};

var castArray = function (arg) {
    var value = arg;
    if (!value || typeof value !== 'object') {
        return [value];
    }
    if (Array.isArray(value)) {
        return value;
    }
    if ('length' in value && typeof value.length === 'number') {
        return Array.from(value);
    }
    // @ts-ignore
    if (Symbol.iterator in value && typeof value[Symbol.iterator] === 'function') {
        return Array.from(value);
    }
    return [value];
};

var defaults = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length < 2) {
        return args[0];
    }
    var target = args.shift();
    var sources = args;
    if (sources.length === 0) {
        return target;
    }
    if (!target || typeof target !== 'object') {
        return target;
    }
    if (typeof Object.assign === 'function') {
        if (sources.length > 1) {
            sources = [Object.assign.apply(Object, __spreadArray([{}], sources, false))];
        }
    }
    for (var _b = 0, sources_1 = sources; _b < sources_1.length; _b++) {
        var source = sources_1[_b];
        if (!source || typeof source !== 'object') {
            continue;
        }
        for (var _c = 0, _d = Object.keys(source); _c < _d.length; _c++) {
            var key = _d[_c];
            (_a = target[key]) !== null && _a !== void 0 ? _a : (target[key] = source[key]);
        }
    }
    return target;
};

// dotted sperate path
var toPath = function (value) {
    return value.split(/\s*\.\s*/);
};

var get = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var target = args[0], key = args[1], defaultValue = args[2];
    var result = target;
    for (var _a = 0, _b = toPath(key); _a < _b.length; _a++) {
        var segment = _b[_a];
        result = result[segment];
        if (result == null) {
            break;
        }
    }
    return result !== null && result !== void 0 ? result : defaultValue;
};

var identity = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args[0];
};

var isEmpty = function (value) {
    return (value === null ||
        typeof (value === null || value === void 0 ? void 0 : value.length) === 'number' && !value.length ||
        typeof (value === null || value === void 0 ? void 0 : value.size) === 'number' && !value.size ||
        typeof value === 'object' && !Object.keys(value).length ||
        typeof value !== 'object');
};

var isPlainObject = function (arg) {
    return arg && typeof arg === 'object' && (Object.getPrototypeOf(arg) === Object.prototype || Object.getPrototypeOf(arg) === null);
};

var last = function (arg) {
    var array = arg;
    if (Array.isArray(array)) {
        return array[array.length - 1];
    }
    if (array && 'length' in array) {
        if (typeof array.length === 'number') {
            array = Array.from(array);
            return array[array.length - 1];
        }
    }
    if (array && 'size' in array) {
        // @ts-ignore
        if (typeof array.size === 'number') {
            array = Array.from(array);
            return array[array.length - 1];
        }
    }
    return undefined;
};

var mapKeys = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var object = args[0], _a = args[1], customizer = _a === void 0 ? identity : _a;
    if (!object || typeof object !== 'object') {
        return {};
    }
    var result = {};
    for (var _b = 0, _c = Object.keys(object); _b < _c.length; _b++) {
        var key = _c[_b];
        var value = object[key];
        result[customizer(key, value, object)] = value;
    }
    return result;
};

var matches = function (source) {
    return function (value) {
        for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
            var key = _a[_i];
            var sourceValue = get(source, key);
            var targetValue = get(value, key);
            if (typeof sourceValue === 'function') {
                if (!sourceValue(targetValue, key, value)) {
                    return false;
                }
            }
            else if (sourceValue != null) {
                if (targetValue !== sourceValue) {
                    return false;
                }
            }
        }
        return true;
    };
};

var mergeWith = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length < 3) {
        return args[0];
    }
    var target = args.shift();
    var customizer = args.pop();
    var sources = args;
    if (!target || typeof target !== 'object') {
        return target;
    }
    if (typeof customizer !== 'function') {
        return target;
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (!source || typeof source !== 'object') {
            continue;
        }
        if (Array.isArray(source) && Array.isArray(target)) {
            for (var i = 0; i < source.length; i += 1) {
                mergeByKey(target, source, i, customizer);
            }
        }
        else if (isPlainObject(source)) {
            for (var _b = 0, _c = Object.keys(source); _b < _c.length; _b++) {
                var key = _c[_b];
                mergeByKey(target, source, key, customizer);
            }
        }
    }
    return target;
};
function mergeByKey(target, source, key, customizer) {
    var _a, _b;
    var producedValue = customizer(target[key], source[key], key, target, source);
    if (typeof producedValue !== 'undefined') {
        target[key] = producedValue;
    }
    if (source[key] && typeof source[key] === 'object') {
        if (!Array.isArray(source[key]) && !isPlainObject(source[key])) {
            (_a = target[key]) !== null && _a !== void 0 ? _a : (target[key] = source[key]);
        }
        else {
            mergeWith((_b = target[key]) !== null && _b !== void 0 ? _b : (target[key] = {}), source[key], customizer);
        }
        return;
    }
    if (target[key] && typeof target[key] === 'object') {
        return;
    }
    target[key] = source[key];
}

var merge = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-ignore
    return mergeWith.apply(null, args.concat(function () { return undefined; }));
};

var hasOwn = function (object, key) { return Object.prototype.hasOwnProperty.call(object, key); };
var pick = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    var object = args.shift();
    var props = args;
    for (var _a = 0, props_1 = props; _a < props_1.length; _a++) {
        var prop = props_1[_a];
        if (Array.isArray(prop)) {
            for (var _b = 0, prop_1 = prop; _b < prop_1.length; _b++) {
                var key = prop_1[_b];
                if (hasOwn(object, key)) {
                    // @ts-ignore
                    result[key] = object[key];
                }
            }
        }
        else {
            if (hasOwn(object, prop)) {
                // @ts-ignore
                result[prop] = object[prop];
            }
        }
    }
    return result;
};

var trim$1 = function (source) {
    var _a, _b, _c;
    return (_c = (_b = (_a = source === null || source === void 0 ? void 0 : source.trim) === null || _a === void 0 ? void 0 : _a.call(source)) !== null && _b !== void 0 ? _b : source === null || source === void 0 ? void 0 : source.replace(/^\s+/, '').replace(/\s+$/, '')) !== null && _c !== void 0 ? _c : '';
};

var ThunkState;
(function (ThunkState) {
    ThunkState[ThunkState["Pending"] = 0] = "Pending";
    ThunkState[ThunkState["Fulfilled"] = 1] = "Fulfilled";
    ThunkState[ThunkState["Rejected"] = 2] = "Rejected";
})(ThunkState || (ThunkState = {}));

function mapIterator(source, callback) {
    return {
        next: function () {
            var _a = source.next(), done = _a.done, value = _a.value;
            return { done: done, value: callback(value) };
        },
    };
}

function mapIteratable(source, callback) {
    var _a;
    var iterator;
    var target = (_a = {
            next: function () {
                iterator !== null && iterator !== void 0 ? iterator : (iterator = mapIterator(source[Symbol.iterator](), callback));
                return iterator.next();
            }
        },
        _a[Symbol.iterator] = function () {
            return this;
        },
        _a);
    return target;
}

function assume(value) { }

var VNodeProxy = /** @class */ (function () {
    function VNodeProxy(vnode, parent) {
        if (parent === void 0) { parent = null; }
        this.vnode = vnode;
        this.parent = parent;
        // assert !this.vnode.$$vnode_proxy
        this.vnode.$$vnode_proxy = this;
    }
    Object.defineProperty(VNodeProxy.prototype, "nodeType", {
        get: function () {
            if (this.vnode.tag || this.vnode.componentOptions) {
                return document.ELEMENT_NODE;
            }
            if (this.vnode.isComment) {
                return document.COMMENT_NODE;
            }
            if (this.vnode.text) {
                return document.TEXT_NODE;
            }
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VNodeProxy.prototype, "empty", {
        get: function () {
            return (this.nodeType === document.COMMENT_NODE ||
                this.nodeType < 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VNodeProxy.prototype, "children", {
        // [ SAME OBJECT ]
        get: function () {
            var _a;
            // lazy
            return (_a = this._childNodes) !== null && _a !== void 0 ? _a : (this._childNodes = new VNodeList(this));
        },
        set: function (children) {
            var _a;
            var _b;
            (_b = this._childNodes) !== null && _b !== void 0 ? _b : (this._childNodes = new VNodeList(this));
            this._childNodes.length = 0;
            (_a = this._childNodes).push.apply(_a, children);
        },
        enumerable: false,
        configurable: true
    });
    VNodeProxy.prototype.previousSibling = function () {
        var _a, _b, _c;
        if (!this.parent) {
            return null;
        }
        assume(this.parent.children);
        var idx = (_b = (_a = this.parent.children) === null || _a === void 0 ? void 0 : _a.indexOf(this.vnode)) !== null && _b !== void 0 ? _b : -1;
        return (_c = this.parent.children.item(idx - 1)) !== null && _c !== void 0 ? _c : null;
    };
    VNodeProxy.prototype.nextSibling = function () {
        var _a, _b;
        if (!this.parent) {
            return null;
        }
        assume(this.parent.children);
        var idx = (_a = this.parent.children.indexOf(this.vnode)) !== null && _a !== void 0 ? _a : -1;
        return (_b = this.parent.children.item(idx + 1)) !== null && _b !== void 0 ? _b : null;
    };
    VNodeProxy.prototype.firstChild = function () {
        var _a;
        assume(this.children);
        if (this.nodeType !== document.ELEMENT_NODE) {
            return null;
        }
        return (_a = this.children.item(0)) !== null && _a !== void 0 ? _a : null;
    };
    VNodeProxy.prototype.lastChild = function () {
        var _a;
        assume(this.children);
        if (this.nodeType !== document.ELEMENT_NODE) {
            return null;
        }
        return (_a = this.children.item(this.children.length - 1)) !== null && _a !== void 0 ? _a : null;
    };
    VNodeProxy.prototype.before = function () {
        var _a;
        var _b;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        if (!this.parent) {
            return;
        }
        var idx = (_b = this.parent.children.indexOf(this.vnode)) !== null && _b !== void 0 ? _b : -1;
        (_a = this.parent.children).splice.apply(_a, __spreadArray([idx, 0], nodes, false));
    };
    VNodeProxy.prototype.after = function () {
        var _a;
        var _b;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        if (!this.parent) {
            return;
        }
        var idx = (_b = this.parent.children.indexOf(this.vnode)) !== null && _b !== void 0 ? _b : -1;
        (_a = this.parent.children).splice.apply(_a, __spreadArray([idx + 1, 0], nodes, false));
    };
    VNodeProxy.prototype.remove = function () {
        var _a;
        if (!this.parent) {
            // fallback
            // make it an empty node
            var VNode = this.vnode.constructor;
            var emptyNode = new VNode();
            emptyNode.text = '';
            emptyNode.isComment = true;
            assign(this.vnode, emptyNode);
            return;
        }
        var idx = (_a = this.parent.children.indexOf(this.vnode)) !== null && _a !== void 0 ? _a : -1;
        this.parent.children.splice(idx, 1);
    };
    VNodeProxy.prototype.cloneNode = function (deep) {
        var _a;
        if (deep === void 0) { deep = false; }
        var VNode = this.vnode.constructor;
        var cloned = new VNode(
        // tag
        this.vnode.tag, 
        // data
        this.vnode.data && merge({}, this.vnode.data), 
        // mergeWith({}, this.vnode.data, data, (objVal: any, srcVal: any) => isReactive(srcVal) ? srcVal : undefined),
        // children
        [], 
        // deep ? (this.rawChildren?.slice()?.filter(Boolean) ?? []) : [],
        // castArray(children ?? this.rawChildren.slice() ?? []).filter(Boolean),
        // text
        this.vnode.text, 
        // element
        this.vnode.elm, 
        // context
        this.vnode.context, 
        // listeners
        this.vnode.componentOptions && merge({}, this.vnode.componentOptions), 
        // this.vnode.componentOptions && merge({}, this.vnode.componentOptions, pick(data, [ 'listeners' ])),
        // @ts-ignore
        this.vnode.asyncFactory);
        assign(cloned, pick(this.vnode, [
            'ns',
            'isStatic',
            'key',
            'isComment',
            'fnContext',
            'fnOptions',
            'fnScopeId',
            'asyncMeta',
        ]), {
            isCloned: true,
        });
        var VNodeProxy = this.constructor;
        var proxy = new VNodeProxy(cloned, this.parent);
        if (deep) {
            if ((_a = this.children) === null || _a === void 0 ? void 0 : _a.length) {
                for (var i = 0; i < this.children.length; i += 1) {
                    // @ts-ignore
                    var child = this.children.item(i);
                    if (child) {
                        proxy.children.push(child.cloneNode(deep).vnode);
                    }
                }
            }
            proxy.children.push();
        }
        return proxy;
    };
    Object.defineProperty(VNodeProxy.prototype, "textContent", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.vnode.data) === null || _a === void 0 ? void 0 : _a.domProps) === null || _b === void 0 ? void 0 : _b.textContent) !== null && _c !== void 0 ? _c : '';
        },
        set: function (content) {
            var _a, _b;
            var _c, _d;
            ((_b = (_d = ((_a = (_c = this.vnode).data) !== null && _a !== void 0 ? _a : (_c.data = {}))).domProps) !== null && _b !== void 0 ? _b : (_d.domProps = {})).textContent = content;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VNodeProxy.prototype, "rawChildren", {
        // [ SAME OBJECT ]
        get: function () {
            var _a;
            var _b;
            return ((_a = (_b = this.vnode).children) !== null && _a !== void 0 ? _a : (_b.children = []));
        },
        enumerable: false,
        configurable: true
    });
    return VNodeProxy;
}());

var VTextNodeProxy = /** @class */ (function (_super) {
    __extends(VTextNodeProxy, _super);
    function VTextNodeProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VTextNodeProxy.prototype, "data", {
        get: function () {
            var _a;
            return (_a = this.vnode.text) !== null && _a !== void 0 ? _a : '';
        },
        set: function (data) {
            this.vnode.text = data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VTextNodeProxy.prototype, "text", {
        get: function () {
            return this.data;
        },
        set: function (text) {
            this.data = text;
        },
        enumerable: false,
        configurable: true
    });
    return VTextNodeProxy;
}(VNodeProxy));

var VNodeIterator = /** @class */ (function () {
    function VNodeIterator(root) {
        this.root = root;
        this.stacks = [[this.root, 0]];
        this.stage = 0 /* VNodeIteratorStage.Enter */;
    }
    VNodeIterator.prototype.next = function () {
        var stacks = this.stacks;
        while (stacks.length > 0) {
            var currentStack = stacks[stacks.length - 1];
            // assert: currentStack
            var currentParent = currentStack[0], currentIndex = currentStack[1];
            var children = currentParent.children;
            if (this.stage === 1 /* VNodeIteratorStage.Exit */) {
                stacks.pop();
                if (children && currentIndex < children.length - 1) {
                    stacks.push([currentParent, currentIndex + 1]);
                    this.stage = 0 /* VNodeIteratorStage.Enter */;
                }
                continue;
            }
            // assert: stage === VNodeIteratorStage.Exit
            if (!children || currentIndex > children.length - 1) {
                this.stage = 1 /* VNodeIteratorStage.Exit */;
                continue;
            }
            var currentNode = children.item(currentIndex);
            stacks.push([currentNode, 0]);
            return { done: false, value: currentNode };
        }
        return { done: true, value: undefined };
    };
    return VNodeIterator;
}());

var VNodeMatcher = /** @class */ (function () {
    function VNodeMatcher(vnode) {
        this.vnode = vnode;
        this.predicates = this.parseJsxQueryPredicateAsPlain(this.vnode);
    }
    VNodeMatcher.prototype.test = function (target) {
        if (!this.predicates) {
            return false;
        }
        for (var _i = 0, _a = Object.keys(this.predicates); _i < _a.length; _i++) {
            var key = _a[_i];
            var predicate = this.predicates[key];
            if (!predicate(get(target, key))) {
                return false;
            }
        }
        return true;
    };
    VNodeMatcher.prototype.toJSON = function () {
        return this.predicates;
    };
    VNodeMatcher.prototype.parseJsxQueryPredicateAsPlain = function (vnode) {
        var proxy = createVNodeProxy(vnode);
        if (proxy.nodeType !== document.ELEMENT_NODE) {
            return null;
        }
        var tagName = proxy.tagName, attrs = proxy.attrs, props = proxy.props, className = proxy.className, style = proxy.style, slot = proxy.slot;
        // @ts-ignore
        if (proxy.functional) {
            // currently not support
            attrs = null;
        }
        var result = {};
        result.tagName = function (v) { return v === tagName; };
        if (attrs && !isEmpty(attrs)) {
            result.attrs = matches(attrs);
        }
        if (props && !isEmpty(props)) {
            result.props = matches(props);
        }
        if (slot) {
            result.slot = function (v) { return v === slot; };
        }
        if (className) {
            var target_1 = className.split(/\s+/);
            result.classList = function (list) { return target_1.every(list.contains.bind(list)); };
        }
        if (style && !isEmpty(style)) {
            result.style = matches(style);
        }
        return result;
    };
    return VNodeMatcher;
}());

var VNodeQuery = /** @class */ (function () {
    function VNodeQuery(startNode, queryOptions) {
        this.startNode = startNode;
        this.queryOptions = queryOptions;
        this.iterator = new VNodeIterator(this.startNode);
        this.predicates = this.parseQueryPredicate(this.queryOptions);
    }
    VNodeQuery.prototype.next = function () {
        while (true) {
            var _a = this.iterator.next(), done = _a.done, value = _a.value;
            if (done) {
                return { done: done, value: value };
            }
            var matched = true;
            for (var _i = 0, _b = Object.keys(this.predicates); _i < _b.length; _i++) {
                var key = _b[_i];
                var predicate = this.predicates[key];
                if (!predicate(get(value, key))) {
                    matched = false;
                    break;
                }
            }
            if (matched) {
                return { done: done, value: value };
            }
        }
    };
    VNodeQuery.prototype[Symbol.iterator] = function () {
        return this;
    };
    VNodeQuery.prototype.parseQueryPredicate = function (queryOptions) {
        if (this.isVNode(queryOptions.as)) {
            var options = new VNodeMatcher(queryOptions.as).toJSON();
            if (options) {
                assign(queryOptions, options);
            }
            delete queryOptions.as;
        }
        if (this.isVNode(queryOptions.parentAs)) {
            assign(queryOptions, { parent: new VNodeMatcher(queryOptions.parentAs) });
            delete queryOptions.parentAs;
        }
        if (this.isVNode(queryOptions.previousSiblingAs)) {
            assign(queryOptions, { previousSibling: new VNodeMatcher(queryOptions.previousSiblingAs) });
            delete queryOptions.previousSiblingAs;
        }
        if (this.isVNode(queryOptions.nextSiblingAs)) {
            assign(queryOptions, { nextSibling: new VNodeMatcher(queryOptions.nextSiblingAs) });
            delete queryOptions.nextSiblingAs;
        }
        return this.parsePlainQueryPredicate(queryOptions);
    };
    VNodeQuery.prototype.parsePlainQueryPredicate = function (queryOptions, level) {
        if (level === void 0) { level = 0; }
        var result = {};
        var _loop_1 = function (key) {
            var option = queryOptions[key];
            if (option == null) {
                return "continue";
            }
            if (typeof option === 'function') {
                result[key] = option;
                return "continue";
            }
            if (typeof option !== 'object') {
                result[key] = function (value) { return value === option; };
                return "continue";
            }
            if ('test' in option) {
                if (typeof option.test === 'function') {
                    result[key] = option.test.bind(option);
                }
                return "continue";
            }
            if (Array.isArray(option)) {
                return "continue";
            }
            if (level > 0) {
                return "continue";
            }
            var subResult = this_1.parsePlainQueryPredicate(option, level + 1);
            for (var _b = 0, _c = Object.keys(subResult); _b < _c.length; _b++) {
                var subKey = _c[_b];
                result["".concat(key, ".").concat(subKey)] = subResult[subKey];
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(queryOptions); _i < _a.length; _i++) {
            var key = _a[_i];
            _loop_1(key);
        }
        return result;
    };
    VNodeQuery.prototype.isVNode = function (target) {
        return (target &&
            typeof target === 'object' &&
            target instanceof this.startNode.vnode.constructor);
    };
    return VNodeQuery;
}());

var TokenList = /** @class */ (function () {
    function TokenList(seperator) {
        if (seperator === void 0) { seperator = ' '; }
        this.seperator = seperator;
        this.tokens = {};
        this.orders = {};
        this.cursor = 0;
    }
    Object.defineProperty(TokenList.prototype, "length", {
        get: function () {
            return this.tokens.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenList.prototype, "value", {
        get: function () {
            return this.orderedItems.join(this.seperator);
        },
        enumerable: false,
        configurable: true
    });
    TokenList.prototype.item = function (index) {
        return this.orderedItems[index];
    };
    TokenList.prototype.contains = function (token) {
        token = trim$1(token);
        return token in this.tokens;
    };
    TokenList.prototype.add = function (token) {
        token = trim$1(token);
        if (token in this.tokens) {
            return;
        }
        this.tokens[token] = true;
        this.orders[token] = this.cursor++;
    };
    TokenList.prototype.remove = function (token) {
        token = trim$1(token);
        delete this.tokens[token];
        delete this.orders[token];
    };
    TokenList.prototype.toggle = function (token) {
        var _a;
        var _b;
        token = trim$1(token);
        if (token in this.tokens) {
            delete this.tokens[token];
        }
        else {
            this.tokens[token] = true;
            (_a = (_b = this.orders)[token]) !== null && _a !== void 0 ? _a : (_b[token] = this.cursor++);
        }
    };
    TokenList.prototype.clear = function () {
        var _a, _b, _c, _d;
        this.tokens = (_b = (_a = Object.create) === null || _a === void 0 ? void 0 : _a.call(Object, null)) !== null && _b !== void 0 ? _b : {};
        this.orders = (_d = (_c = Object.create) === null || _c === void 0 ? void 0 : _c.call(Object, null)) !== null && _d !== void 0 ? _d : {};
    };
    Object.defineProperty(TokenList.prototype, "orderedItems", {
        get: function () {
            var _this = this;
            return Object.keys(this.tokens).sort(function (t1, t2) { var _a, _b; return ((_a = _this.orders[t1]) !== null && _a !== void 0 ? _a : 0) - ((_b = _this.orders[t2]) !== null && _b !== void 0 ? _b : 0); });
        },
        enumerable: false,
        configurable: true
    });
    return TokenList;
}());

var classnamesExports = {};
var classnames = {
  get exports(){ return classnamesExports; },
  set exports(v){ classnamesExports = v; },
};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var classNames = classnamesExports;

var ClassList = /** @class */ (function (_super) {
    __extends(ClassList, _super);
    function ClassList(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        var className = classNames(_this.data.staticClass, _this.data.class);
        for (var _i = 0, _a = className.split(/\s+/); _i < _a.length; _i++) {
            var token = _a[_i];
            _this.add(token);
        }
        _this.data.class = _this.tokens;
        _this.data.staticClass = '';
        return _this;
    }
    return ClassList;
}(TokenList));

var styleToObjectExports = {};
var styleToObject = {
  get exports(){ return styleToObjectExports; },
  set exports(v){ styleToObjectExports = v; },
};

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
var inlineStyleParser = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) ; else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var parse = inlineStyleParser;

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

styleToObject.exports = StyleToObject;
styleToObjectExports.default = StyleToObject; // ESM support

var parseStyle = styleToObjectExports;

var StyleDeclaration = /** @class */ (function () {
    function StyleDeclaration(data) {
        this.data = data;
        this.data.style = this.normalize(this.data.style);
    }
    Object.defineProperty(StyleDeclaration.prototype, "style", {
        // [SAME-OBJECT]
        get: function () {
            return defaults(this.data.style, this.data.staticStyle);
        },
        set: function (style) {
            var _a;
            this.data.staticStyle = {};
            if (typeof style === 'string') {
                this.data.style = (_a = parseStyle(style)) !== null && _a !== void 0 ? _a : {};
            }
            else {
                this.data.style = style;
            }
        },
        enumerable: false,
        configurable: true
    });
    StyleDeclaration.prototype.normalize = function (style) {
        var _a;
        if (typeof style === 'string') {
            return (_a = parseStyle(style)) !== null && _a !== void 0 ? _a : {};
        }
        if (Array.isArray(style)) {
            style = style.map(this.normalize);
            return assign.apply(void 0, __spreadArray([{}], style, false));
        }
        if (typeof style === 'object' && style) {
            return mapKeys(style, camelCase);
        }
        return {};
    };
    return StyleDeclaration;
}());

var VElementProxy = /** @class */ (function (_super) {
    __extends(VElementProxy, _super);
    function VElementProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VElementProxy.prototype, "tagName", {
        get: function () {
            return this.vnode.tag;
        },
        set: function (tag) {
            this.vnode.tag = tag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "className", {
        get: function () {
            return this.classList.value;
        },
        set: function (className) {
            this.classList.clear();
            for (var _i = 0, _a = className.split(/\s+/); _i < _a.length; _i++) {
                var token = _a[_i];
                this.classList.add(token);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "classList", {
        // [SAME OBJECT]
        get: function () {
            var _a;
            // lazy
            return (_a = this._classList) !== null && _a !== void 0 ? _a : (this._classList = new ClassList(this.data));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "style", {
        // [SAME OBJECT]
        get: function () {
            var _a;
            // lazy
            return ((_a = this._styleDeclaration) !== null && _a !== void 0 ? _a : (this._styleDeclaration = new StyleDeclaration(this.data))).style;
        },
        set: function (style) {
            var _a;
            (_a = this._styleDeclaration) !== null && _a !== void 0 ? _a : (this._styleDeclaration = new StyleDeclaration(this.data));
            this._styleDeclaration.style = style;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "attrs", {
        // [SAME OBJECT]
        get: function () {
            var _a;
            var _b;
            var attrs = assign((_a = (_b = this.data).attrs) !== null && _a !== void 0 ? _a : (_b.attrs = {}), this.data.props);
            // reset props
            this.data.props = {};
            return attrs;
        },
        set: function (attrs) {
            this.data.attrs = attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "props", {
        get: function () {
            return this.attrs;
        },
        set: function (props) {
            this.attrs = props;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "scopedSlots", {
        // [ SAME OBJECT ]
        get: function () {
            var _a;
            var _b;
            return (_a = (_b = this.data).scopedSlots) !== null && _a !== void 0 ? _a : (_b.scopedSlots = {});
        },
        set: function (slots) {
            this.data.scopedSlots = slots;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "listeners", {
        // [ SAME OBJECT ]
        get: function () {
            var _a;
            var _b;
            return (_a = (_b = this.data).on) !== null && _a !== void 0 ? _a : (_b.on = {});
        },
        set: function (listeners) {
            this.data.on = listeners;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "nativeListeners", {
        // [ SAME OBJECT ]
        get: function () {
            var _a;
            var _b;
            return (_a = (_b = this.data).nativeOn) !== null && _a !== void 0 ? _a : (_b.nativeOn = {});
        },
        set: function (listeners) {
            this.data.nativeOn = listeners;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "key", {
        get: function () {
            return this.data.key;
        },
        set: function (key) {
            this.data.key = key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "ref", {
        get: function () {
            return this.data.ref;
        },
        set: function (ref) {
            this.data.ref = ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VElementProxy.prototype, "slot", {
        get: function () {
            return this.data.slot;
        },
        set: function (slot) {
            this.data.slot = slot;
        },
        enumerable: false,
        configurable: true
    });
    VElementProxy.prototype.previousElementSibling = function () {
        if (!this.parent) {
            return null;
        }
        var ref = this;
        do {
            var sibiling = ref.previousSibling();
            if (!sibiling) {
                break;
            }
            if (sibiling.nodeType === document.ELEMENT_NODE) {
                return sibiling;
            }
            ref = sibiling;
        } while (true);
        return null;
    };
    VElementProxy.prototype.nextElementSibling = function () {
        if (!this.parent) {
            return null;
        }
        var ref = this;
        do {
            var sibiling = ref.nextSibling();
            if (!sibiling) {
                break;
            }
            if (sibiling.nodeType === document.ELEMENT_NODE) {
                return sibiling;
            }
            ref = sibiling;
        } while (true);
        return null;
    };
    VElementProxy.prototype.firstElementChild = function () {
        var child = this.firstChild();
        if (!child) {
            return null;
        }
        if (child.nodeType === document.ELEMENT_NODE) {
            return child;
        }
        return this.nextElementSibling.call(child);
    };
    VElementProxy.prototype.lastElementChild = function () {
        var child = this.lastChild();
        if (!child) {
            return null;
        }
        if (child.nodeType === document.ELEMENT_NODE) {
            return child;
        }
        return this.previousElementSibling.call(child);
    };
    VElementProxy.prototype.prepend = function () {
        var _a;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        (_a = this.children).unshift.apply(_a, nodes.map(this.normalizeVNodes.bind(this)));
    };
    VElementProxy.prototype.append = function () {
        var _a;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        (_a = this.children).push.apply(_a, nodes.map(this.normalizeVNodes.bind(this)));
    };
    VElementProxy.prototype.replaceChildren = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.children = nodes.map(this.normalizeVNodes.bind(this));
    };
    VElementProxy.prototype.query = function (predicates) {
        return new VNodeQuery(this, predicates);
    };
    VElementProxy.prototype.queryNode = function (predicates) {
        return mapIteratable(this.query(predicates), function (value) { return value === null || value === void 0 ? void 0 : value.vnode; });
    };
    VElementProxy.prototype.matches = function (vnode) {
        return new VNodeMatcher(vnode).test(this);
    };
    Object.defineProperty(VElementProxy.prototype, "data", {
        get: function () {
            var _a;
            var _b;
            return (_a = (_b = this.vnode).data) !== null && _a !== void 0 ? _a : (_b.data = {});
        },
        enumerable: false,
        configurable: true
    });
    VElementProxy.prototype.normalizeVNodes = function (node) {
        if (typeof node === 'string') {
            return this.createTextVNode(node);
        }
        return node;
    };
    VElementProxy.prototype.createTextVNode = function (text) {
        var VNode = this.vnode.constructor;
        return new VNode(undefined, undefined, undefined, String(text));
    };
    return VElementProxy;
}(VNodeProxy));

var VFunctionalElementProxy = /** @class */ (function (_super) {
    __extends(VFunctionalElementProxy, _super);
    function VFunctionalElementProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VFunctionalElementProxy.prototype, "functional", {
        get: function () {
            var _a;
            return Boolean((_a = this.vnode.fnOptions) === null || _a === void 0 ? void 0 : _a.functional);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "tagName", {
        get: function () {
            return this.vnode.fnOptions.name;
        },
        set: function (tag) {
            // stub
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "attrs", {
        // [SAME OBJECT]
        get: function () {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = this.vnode.devtoolsMeta) === null || _a === void 0 ? void 0 : _a.renderContext) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.attrs) !== null && _d !== void 0 ? _d : {};
        },
        set: function (attrs) {
            // stub
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "props", {
        // [SAME OBJECT]
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.vnode.devtoolsMeta) === null || _a === void 0 ? void 0 : _a.renderContext) === null || _b === void 0 ? void 0 : _b.props) !== null && _c !== void 0 ? _c : {};
        },
        set: function (props) {
            // stub
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "scopedSlots", {
        // [ SAME OBJECT ]
        get: function () {
            var _a, _b, _c;
            // stub
            return (_c = (_b = (_a = this.vnode.devtoolsMeta) === null || _a === void 0 ? void 0 : _a.renderContext) === null || _b === void 0 ? void 0 : _b.scopedSlots) !== null && _c !== void 0 ? _c : {};
        },
        set: function (slots) {
            // stub
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "listeners", {
        // [ SAME OBJECT ]
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.vnode.devtoolsMeta) === null || _a === void 0 ? void 0 : _a.renderContext) === null || _b === void 0 ? void 0 : _b.listeners) !== null && _c !== void 0 ? _c : {};
        },
        set: function (listeners) {
            // stub
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "nativeListeners", {
        // [ SAME OBJECT ]
        get: function () {
            // stub
            return {};
        },
        set: function (listeners) {
            // stub
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VFunctionalElementProxy.prototype, "data", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (_a = this._functionalData) !== null && _a !== void 0 ? _a : (this._functionalData = (_d = (_c = (_b = this.vnode.devtoolsMeta) === null || _b === void 0 ? void 0 : _b.renderContext) === null || _c === void 0 ? void 0 : _c.data) !== null && _d !== void 0 ? _d : assign({}, this.vnode.data, {
                class: last(castArray((_f = (_e = this.vnode.data) === null || _e === void 0 ? void 0 : _e.class) !== null && _f !== void 0 ? _f : '')),
                style: last(castArray((_h = (_g = this.vnode.data) === null || _g === void 0 ? void 0 : _g.style) !== null && _h !== void 0 ? _h : {})),
            }));
        },
        enumerable: false,
        configurable: true
    });
    return VFunctionalElementProxy;
}(VElementProxy));

var VCustomElementProxy = /** @class */ (function (_super) {
    __extends(VCustomElementProxy, _super);
    function VCustomElementProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VCustomElementProxy.prototype, "custom", {
        get: function () {
            return Boolean(this.vnode.componentOptions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VCustomElementProxy.prototype, "tagName", {
        /** @override */
        get: function () {
            return this.vnode.componentOptions.tag;
        },
        set: function (tag) {
            this.vnode.componentOptions.tag = tag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VCustomElementProxy.prototype, "props", {
        /** @override */
        get: function () {
            var _a;
            var _b;
            var props = defaults((_a = (_b = this.vnode.componentOptions).propsData) !== null && _a !== void 0 ? _a : (_b.propsData = {}), this.data.attrs, this.data.props);
            // reset props
            this.data.props = {};
            return props;
        },
        set: function (props) {
            this.vnode.componentOptions.propsData = props;
            // reset
            this.data.props = {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VCustomElementProxy.prototype, "model", {
        get: function () {
            // @ts-ignore
            return this.data.model;
        },
        set: function (model) {
            // @ts-ignore
            this.data.model = model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VCustomElementProxy.prototype, "rawChildren", {
        /** @override */
        get: function () {
            var _a;
            var _b;
            return ((_a = (_b = this.vnode.componentOptions).children) !== null && _a !== void 0 ? _a : (_b.children = []));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VCustomElementProxy.prototype, "listeners", {
        /** @override */
        get: function () {
            var _a;
            var _b;
            return ((_a = (_b = this.vnode.componentOptions).listeners) !== null && _a !== void 0 ? _a : (_b.listeners = {}));
        },
        set: function (listeners) {
            this.vnode.componentOptions.listeners = listeners;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VCustomElementProxy.prototype, "nativeListeners", {
        /** @override */
        get: function () {
            var _a, _b;
            var _c, _d;
            return (_b = (_d = ((_a = (_c = this.vnode).data) !== null && _a !== void 0 ? _a : (_c.data = {}))).on) !== null && _b !== void 0 ? _b : (_d.on = {});
        },
        set: function (listeners) {
            var _a;
            var _b;
            ((_a = (_b = this.vnode).data) !== null && _a !== void 0 ? _a : (_b.data = {})).on = listeners;
        },
        enumerable: false,
        configurable: true
    });
    return VCustomElementProxy;
}(VElementProxy));

function createVNodeProxy(node, parent) {
    var _a, _b;
    if (parent === void 0) { parent = null; }
    return (_a = node.$$vnode_proxy) !== null && _a !== void 0 ? _a : (node.$$vnode_proxy = node.componentOptions ? new VCustomElementProxy(node, parent) :
        ((_b = node.fnOptions) === null || _b === void 0 ? void 0 : _b.functional) ? new VFunctionalElementProxy(node, parent) :
            node.tag ? new VElementProxy(node, parent) :
                new VTextNodeProxy(node, parent));
}

export { createVNodeProxy };
//# sourceMappingURL=index.esm.js.map
